import React, { useMemo } from 'react'
import { Box, Flex, Center } from '@chakra-ui/react'
import {
    ActionItemFieldsFragment,
    ActionItemType,
} from '~graphql/generated/graphql'
import BoardingContent from './action-item-content/boarding-content'
import MissingClientContent from './action-item-content/missing-client-content'
import NewChatContent from './action-item-content/new-chat-content'
import OfficeTaskContent from './action-item-content/office-task-content'
import PendingAppointmentContent from './action-item-content/pending-appointment-content'
import PrescriptionContent from './action-item-content/prescription-content'
import RescheduleContent from './action-item-content/reschedule-content'
import { SharedTypeIcon } from './action-item-content/shared'
import AssigneeSelect from '~components/pending-actions/pending-item-rows/assignee-select'
import UnderReviewFlag from '~components/pending-actions/pending-item-rows/under-review-flag'
import FormSubmittedContent from './action-item-content/form-submitted-content'
import PetSelfieContent from './action-item-content/pet-selfie-content'
import SharedStack from '~components/shared/wrappers/shared-stack'

interface Props {
    actionItem: ActionItemFieldsFragment
}

const ActionItemBlock: React.FC<Props> = ({ actionItem }) => {
    const content = {
        [ActionItemType.PendingAppointment]: PendingAppointmentContent,
        [ActionItemType.Reschedule]: RescheduleContent,
        [ActionItemType.NewChat]: NewChatContent,
        [ActionItemType.Boarding]: BoardingContent,
        [ActionItemType.Prescription]: PrescriptionContent,
        [ActionItemType.OfficeTask]: OfficeTaskContent,
        [ActionItemType.General]: ({
            actionItem,
        }: {
            actionItem: ActionItemFieldsFragment
        }) => <Box>General</Box>,
        [ActionItemType.MissingClient]: MissingClientContent,
        [ActionItemType.MissingPatient]: MissingClientContent,
        [ActionItemType.FormSubmitted]: FormSubmittedContent,
        [ActionItemType.PetSelfieSubmitted]: PetSelfieContent,
    }[actionItem.type]

    return (
        <ActionItemCard>
            <SharedStack
                w={{
                    base: 'full',
                    md: 'fit-content',
                }}
                spacing={4}
                align="center"
                flexDir={{ base: 'row-reverse', md: 'row' }}
                justify={{
                    base: 'space-between',
                    md: 'flex-start',
                }}
            >
                <Center
                    flexDir={{ base: 'row-reverse', md: 'column' }}
                    w="fit-content"
                    gap={1}
                >
                    <AssigneeSelect actionItem={actionItem} size="xs" />
                    <UnderReviewFlag actionItem={actionItem} size="sm" />
                </Center>
                <SharedTypeIcon type={actionItem.type} />
            </SharedStack>
            <Box flex={1}>{content({ actionItem })}</Box>
        </ActionItemCard>
    )
}
export default ActionItemBlock

/** Card shell shared by every row in the home page "Action Required" list. */
export function ActionItemCard({ children }: { children: React.ReactNode }) {
    return (
        <Flex
            flexDir={{ base: 'column', md: 'row' }}
            alignItems="center"
            w="full"
            py={3}
            px={3}
            gridGap={4}
            bg="white"
            rounded="xl"
            shadow="blue.md"
            borderWidth={1}
            borderColor="gray.100"
        >
            {children}
        </Flex>
    )
}
